import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';

const DeleteRecurringInventoryItemConfirmationModal = ({ open, onClose, onDelete, item }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      if (onDelete) await onDelete();
      onClose();
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const itemName      = item?.name || 'this item';
  const buildingName  = item?.property_details?.building_name || 'unknown property';
  const locationRoom  = item?.locationDetails?.room ? ` in room ${item.locationDetails.room}` : '';
  const quantityActive = item?.quantity?.active != null ? ` (${item.quantity.active} active)` : '';

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Confirm Deletion</ModalHeader>
      <ModalBody>
        <p className="mb-0">
          Are you sure you want to delete <strong>{itemName}</strong>{quantityActive}{locationRoom} at{' '}
          <strong>{buildingName}</strong>?
          <br />
          <small className="text-muted">
            This action cannot be undone. Any associated invoices, images, or warranty records linked
            only to this item will also be affected.
          </small>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
        <Button color="danger" onClick={handleConfirm} disabled={loading}>
          {loading && <Spinner size="sm" className="me-2" />}
          {loading ? 'Deleting…' : 'Delete Item'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { DeleteRecurringInventoryItemConfirmationModal };